function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#4F4F4F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.166 10.952a.715.715 0 00-.006 1.006l3.325 3.33H8.83a.708.708 0 00-.705.712c0 .393.317.71.705.71h12.65l-3.325 3.331a.72.72 0 00.005 1.006.708.708 0 001-.005l4.507-4.54a.797.797 0 00.148-.223.713.713 0 00-.148-.771l-4.506-4.54a.697.697 0 00-.995-.016z",
  fill: "#fff"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgArrowRight;